import { Schema as S } from "effect";

export const TagInputVariant = S.Literals(["external", "internal"]);

export const Model = S.Struct({
	page: S.Literal("Developers"),
	tagInputVariant: TagInputVariant,
});
export type Model = typeof Model.Type;
